import React from "react";
import axios from "axios";
import Switch from "@mui/material/Switch";
import { green } from "@mui/material/colors";
import { red } from "@mui/material/colors";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

export default function UserAccess({ id }) {
    const [rows, setRows] = useState([]);
    const [accesses, setAccesses] = useState([]);
    const [select, setSelect] = useState(null);

    useEffect(() => {
        getAccesses();
    }, []);

    const getAccesses = async () => {
        await axios
            .get(`${process.env.REACT_APP_URL}/api/idp/v2/project/${id}/access`, {
                headers: { Authorization: sessionStorage.getItem("token") },
            })
            .then((res) => {
                setAccesses(res.data.data);
                setRows(res.data.data.map((e) => ({ ...e })));
            })
            .catch((err) => {
                toast.error("An error occurred");
                console.log(err.message);
            });
    };

    function isChange() {
        for (let i = 0; i < accesses.length; i++) {
            if (accesses[i].view !== rows[i].view || accesses[i].admin !== rows[i].admin) {
                return true;
            }
        }
        return false;
    }

    async function submit() {
        setSelect(null);
        await axios
            .patch(`${process.env.REACT_APP_URL}/api/idp/v2/project/${id}/access`, rows, {
                headers: { Authorization: sessionStorage.getItem("token") },
            })
            .then(async (res) => {
                await getAccesses();
                toast.success("Successfully updated!");
            })
            .catch((err) => {
                toast.error("An error occurred");
            });
    }

    function cancelChange() {
        let x = [];
        for (let i = 0; i < accesses.length; i++) {
            const element = { ...accesses[i] };
            x.push(element);
        }

        setRows(x);
    }

    return (
        <div className="relative overflow-x-auto sm:rounded-lg mb-10">
            {rows.length > 0 && (
                <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" className="px-11 py-3">
                                Name
                            </th>
                            <th scope="col" className="px-6 py-3 text-center">
                                View
                            </th>
                            <th scope="col" className="px-6 py-3 text-center">
                                Admin
                            </th>
                            <th scope="col" className="px-6 py-3 text-center"></th>
                            <th scope="col" className="px-6 py-3 text-center"></th>
                        </tr>
                    </thead>

                    <tbody>
                        {rows.map((access) => (
                            <tr key={access.user} className="bg-white dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                <td className="px-11 p-4">{access.user_name}</td>
                                <td className="px-6 text-center">
                                    {access.user !== select ? (
                                        access.view === "1" ? (
                                            <CheckIcon sx={{ color: green[500] }} />
                                        ) : (
                                            <CloseIcon sx={{ color: red[400] }} />
                                        )
                                    ) : (
                                        <Switch
                                            defaultChecked={access.view === "1"}
                                            value={access.view === "1"}
                                            onChange={(e) => {
                                                let x = rows.findIndex((e) => e.user === access.user);
                                                rows[x].view = rows[x].view === "1" ? "0" : "1";
                                                setRows(rows);
                                            }}
                                            inputProps={{ "aria-label": "controlled" }}
                                        />
                                    )}
                                </td>
                                <td className="px-6 text-center">
                                    {access.user !== select ? (
                                        access.admin === "1" ? (
                                            <CheckIcon sx={{ color: green[500] }} />
                                        ) : (
                                            <CloseIcon sx={{ color: red[400] }} />
                                        )
                                    ) : (
                                        <Switch
                                            defaultChecked={access.admin === "1"}
                                            value={access.admin === "1"}
                                            onChange={(e) => {
                                                let x = rows.findIndex((e) => e.user === access.user);
                                                rows[x].admin = rows[x].admin === "1" ? "0" : "1";
                                                setRows(rows);
                                            }}
                                            inputProps={{ "aria-label": "controlled" }}
                                        />
                                    )}
                                </td>
                                <td className="px-6 text-center">
                                    <button
                                        onClick={(e) => setSelect(null)}
                                        className="bg-rose-300 hover:bg-rose-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center my-2"
                                        style={{ visibility: "hidden" }}
                                    >
                                        cancel
                                    </button>
                                </td>
                                <td className="px-6 text-center">
                                    <button
                                        onClick={(e) => setSelect(access.user)}
                                        className="bg-indigo-300 hover:bg-indigo-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center my-2"
                                        style={{
                                            display:
                                                access.user !== select
                                                    ? // && access.admin === "1"
                                                      "inherit"
                                                    : "none",
                                        }}
                                    >
                                        <div style={{ width: "60px" }}>change</div>
                                    </button>
                                    <button
                                        onClick={(e) => setSelect(null)}
                                        className="bg-green-300 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center my-2"
                                        style={{ display: access.user === select ? "inherit" : "none" }}
                                    >
                                        <div style={{ width: "60px" }}>done</div>
                                    </button>
                                </td>
                            </tr>
                        ))}
                        <tr className="bg-white dark:bg-gray-800 dark:border-gray-700">
                            <td className="px-6 p-4"></td>
                            <td className="px-6 p-4"></td>
                            <td className="px-6 p-4"></td>
                            <td className="px-6 text-center">
                                <button
                                    onClick={cancelChange}
                                    className="bg-rose-300 hover:bg-rose-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center my-2"
                                    style={{ visibility: !isChange() ? "hidden" : "visible" }}
                                >
                                    cancel
                                </button>
                            </td>
                            <td className="px-6 text-center">
                                <button
                                    onClick={submit}
                                    className="bg-green-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center my-2"
                                    style={{ visibility: !isChange() ? "hidden" : "visible" }}
                                >
                                    <div style={{ width: "60px" }}>save</div>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            )}
        </div>
    );
}
